import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex flex-row justify-content-between align-items-center" }
const _hoisted_3 = { class: "btn-toolbar" }
const _hoisted_4 = {
  key: 0,
  class: "form-check form-switch"
}
const _hoisted_5 = { class: "card-body small" }
const _hoisted_6 = { class: "row mb-1" }
const _hoisted_7 = { class: "col-7" }
const _hoisted_8 = {
  key: 0,
  class: "row mb-1"
}
const _hoisted_9 = { class: "col-7" }
const _hoisted_10 = {
  key: 1,
  class: "row mb-1"
}
const _hoisted_11 = { class: "col-7" }
const _hoisted_12 = {
  key: 2,
  class: "row mb-1"
}
const _hoisted_13 = { class: "col-7" }
const _hoisted_14 = {
  key: 3,
  class: "row mb-1"
}
const _hoisted_15 = { class: "col-7" }
const _hoisted_16 = {
  key: 1,
  class: "text-center text-muted py-2"
}
const _hoisted_17 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_18 = { class: "form-floating" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 3,
  class: "mt-2 text-center"
}
const _hoisted_21 = {
  key: 0,
  class: "card-footer d-flex justify-content-center"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "fas fa-unlink fa-fw me-1"
}
const _hoisted_24 = {
  key: 1,
  class: "fas fa-spinner fa-spin fa-fw me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("span", null, [
        _createElementVNode("i", { class: "fab fa-telegram fa-fw me-1" }),
        _createTextVNode("Vinculación de Telegram ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.linkedData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input secondary",
                type: "checkbox",
                role: "switch",
                id: "enable-telegram-link",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enabled) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.enabled]
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.linkedData)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass({ 'text-muted': !_ctx.enabled })
          }, [
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "col-5 fw-bold" }, "Telegram ID:", -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.linkedData.userId), 1)
            ]),
            (_ctx.linkedData.firstName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "col-5 fw-bold" }, "Nombre:", -1)),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.linkedData.firstName) + _toDisplayString(_ctx.linkedData.lastName ? " " + _ctx.linkedData.lastName : ""), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.linkedData.username)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "col-5 fw-bold" }, "Username:", -1)),
                  _createElementVNode("span", _hoisted_11, "@" + _toDisplayString(_ctx.linkedData.username), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.linkedData.phoneNumber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "col-5 fw-bold" }, "Teléfono:", -1)),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.linkedData.phoneNumber), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.linkedData.linkedAt)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "col-5 fw-bold" }, "Vinculado:", -1)),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatDate(_ctx.linkedData.linkedAt)), 1)
                ]))
              : _createCommentVNode("", true)
          ], 2))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "fas fa-circle-info fa-fw me-1" }, null, -1),
            _createTextVNode("Sin cuenta de Telegram vinculada ", -1)
          ]))])),
      (_ctx.linkedData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control text-center fw-bold", { 'bg-light': _ctx.enabled, 'bg-body text-muted': !_ctx.enabled }]),
                placeholder: "Motivo (opcional)",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reason) = $event)),
                disabled: _ctx.unlinking || !_ctx.enabled,
                id: "unlink-reason"
              }, null, 10, _hoisted_19), [
                [_vModelText, _ctx.reason]
              ]),
              _createElementVNode("label", {
                for: "unlink-reason",
                class: _normalizeClass({ 'text-muted': !_ctx.enabled })
              }, "Motivo (opcional)", 2)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.resultMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("span", {
              class: _normalizeClass(['small', _ctx.resultSuccess ? 'text-success' : 'text-danger'])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([
              'fas',
              'fa-fw',
              'me-1',
              _ctx.resultSuccess ? 'fa-check-circle' : 'fa-exclamation-circle',
            ])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(_ctx.resultMessage), 1)
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.linkedData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("button", {
            class: "btn btn-outline-warning col-6",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.doUnlink && _ctx.doUnlink(...args))),
            disabled: _ctx.unlinking || !_ctx.enabled
          }, [
            (!_ctx.unlinking)
              ? (_openBlock(), _createElementBlock("i", _hoisted_23))
              : _createCommentVNode("", true),
            (_ctx.unlinking)
              ? (_openBlock(), _createElementBlock("i", _hoisted_24))
              : _createCommentVNode("", true),
            _cache[10] || (_cache[10] = _createTextVNode(" Desvincular ", -1))
          ], 8, _hoisted_22)
        ]))
      : _createCommentVNode("", true)
  ]))
}